import React from 'react';
import { Box, Link, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const GlobalFooter: React.FC = () => {
  return (
    <Paper
      elevation={1}
      sx={{
        position: 'fixed',
        bottom: 15,
        right: 15,
        display: 'flex',
        padding: '4px 14px',
        backgroundColor: 'white',
        borderRadius: 30,
        zIndex: 1000,
        border: '1px solid rgba(0, 0, 0, 0.1)',
        maxHeight: '28px',
        alignItems: 'center'
      }}
    >
      <Link
        component={RouterLink}
        to="/privacy"
        sx={{
          fontSize: '0.82rem',
          color: 'rgb(95, 99, 104)',
          textDecoration: 'none',
          fontWeight: 400,
          lineHeight: 1.4,
          paddingTop: '1px',
          paddingBottom: '1px',
          '&:hover': { color: 'primary.main' },
        }}
      >
        Privacy
      </Link>
      <Box 
        component="span" 
        sx={{ 
          mx: 0.5, 
          color: 'rgb(95, 99, 104)', 
          fontWeight: 300,
          fontSize: '0.82rem',
          opacity: 0.8
        }}
      >
        -
      </Box>
      <Link
        component={RouterLink}
        to="/terms"
        sx={{
          fontSize: '0.82rem',
          color: 'rgb(95, 99, 104)',
          textDecoration: 'none',
          fontWeight: 400,
          lineHeight: 1.4,
          paddingTop: '1px',
          paddingBottom: '1px',
          '&:hover': { color: 'primary.main' },
        }}
      >
        Terms
      </Link>
    </Paper>
  );
};

export default GlobalFooter; 